import { render, staticRenderFns } from "./CheckPage.vue?vue&type=template&id=a9b7e406&"
import script from "./CheckPage.vue?vue&type=script&lang=js&"
export * from "./CheckPage.vue?vue&type=script&lang=js&"
import style0 from "./CheckPage.vue?vue&type=style&index=0&id=a9b7e406&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports